import { Button } from "@heroui/react";
import { PlusIcon } from "lucide-react";
import clsx from "clsx";
import { twMerge } from "tailwind-merge";

const cn = (...inputs) => twMerge(clsx(inputs));

/**
 * @param {{
 *   onClick?: any;
 *   children?: any;
 *   startContent?: any;
 *   className?: string;
 *   endContent?: any;
 *   size?: string;
 *   disabled?: boolean;
 *   isLoading?: boolean;
 *   type?: string;
 *   title?: string;
 *   "aria-label"?: string;
 * }} [props]
 */
export function PrimaryButton({
  onClick,
  children = "Add New",
  startContent,
  className = "",
  endContent,
  size = "sm",
  disabled = false,
  isLoading = false,
  type = "button",
  title,
  "aria-label": ariaLabel,
} = {}) {
  return (
    <Button
      type={type}
      title={title}
      aria-label={ariaLabel}
      onPress={onClick}
      className={cn(
        `!text-white px-[14px] text-xs py-[8px] gap-[8px] bg-secondary font-medium rounded-lg shadow-[0_4px_4px_0_rgba(255,255,255,0.25)_inset] ${disabled ? "bg-gray-500" : ""
        }`,
        className,
      )}
      startContent={
        startContent ? (
          startContent
        ) : startContent !== false ? (
          <PlusIcon size={18} color="#fff" className="text-small" />
        ) : undefined
      }
      size={size}
      isDisabled={disabled}
      isLoading={isLoading}
    >
      {children}
      {endContent && <span>{endContent}</span>}
    </Button>
  );
}
